define('gigaset_recurring/classes/provider/billwerk/steps/cart_dummy',[
	"jquery",
	"lodash",
	"./_abstract",
	"cartware/jquery/bem",
	"cartware/components/Logger",
	"cartware/components/Config",
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Logger,
	Config
) {

	function CartStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring.cart");
	}

	CartStep.prototype = _.create(new AbstractStep, {
		constructor: CartStep,

		_displayInSidebar: false,

		redirectToCartOnOpen: false,
		cartUrl: '',

		initialize: function() {
			this.cartUrl = Config.get('recurring.checkout.url.cart');
		},

		/**
		 * Open this step
		 * @returns {AbstractStep}
		 */
		open: function() {
			if (this.redirectToCartOnOpen) {
				document.location = this.cartUrl;
				return this;
			}

			this.redirectToCartOnOpen = true;
			// AbstractStep.prototype.open.apply(this, arguments);
			this.next({
				immediately: true
			});
			return this;
		}

	});

	return CartStep;

});
